/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PreAuthFunnelBrandCounts interface.
 */
export function instanceOfPreAuthFunnelBrandCounts(value) {
    if (!('brand' in value) || value['brand'] === undefined)
        return false;
    if (!('contentScriptInjected' in value) || value['contentScriptInjected'] === undefined)
        return false;
    if (!('domain' in value) || value['domain'] === undefined)
        return false;
    if (!('extensionInstalled' in value) || value['extensionInstalled'] === undefined)
        return false;
    if (!('firstAiGenerationCompleted' in value) || value['firstAiGenerationCompleted'] === undefined)
        return false;
    return true;
}
export function PreAuthFunnelBrandCountsFromJSON(json) {
    return PreAuthFunnelBrandCountsFromJSONTyped(json, false);
}
export function PreAuthFunnelBrandCountsFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'brand': json['brand'],
        'contentScriptInjected': json['contentScriptInjected'],
        'domain': json['domain'],
        'extensionInstalled': json['extensionInstalled'],
        'firstAiGenerationCompleted': json['firstAiGenerationCompleted'],
    };
}
export function PreAuthFunnelBrandCountsToJSON(json) {
    return PreAuthFunnelBrandCountsToJSONTyped(json, false);
}
export function PreAuthFunnelBrandCountsToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'brand': value['brand'],
        'contentScriptInjected': value['contentScriptInjected'],
        'domain': value['domain'],
        'extensionInstalled': value['extensionInstalled'],
        'firstAiGenerationCompleted': value['firstAiGenerationCompleted'],
    };
}
